import { Component, OnInit, ViewChild } from "@angular/core";
import { Dropdown } from "primeng/dropdown";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DialogService, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { GroupActionCommentComponent } from "../../../shared/group-action-comment/group-action-comment.component";
import { GroupActionService } from "../../../shared/group-action.service";
import {
	wsGroupActionAdvancedIncidentAssignedInfractionInfo,
	wsGroupActionAdvancedIncidentAssignedPenaltyInfo,
	wsGroupActionAdvancedIncidentCalendarDataInfo,
	wsGroupActionAdvancedIncidentCalendarDataParm,
	wsGroupActionAdvancedIncidentCommentInfo,
	wsGroupActionAdvancedIncidentDataInfo,
	wsGroupActionAdvancedIncidentDataParm,
	wsGroupActionAdvancedIncidentFacilityLocationDataInfo,
	wsGroupActionAdvancedIncidentInfractionInfo,
	wsGroupActionAdvancedIncidentPenaltyInfo,
	wsGroupActionAdvancedIncidentPenaltyRefreshInfo,
	wsGroupActionAdvancedIncidentPenaltyRefreshInfractionsParm,
	wsGroupActionAdvancedIncidentPenaltyRefreshParm,
} from "../../../shared/GroupActionAdvanced";
import { StudentGroupsTableRefreshService } from "../../../shared/student-groups-table-refresh.service";
import * as moment from "moment";

@Component({
	selector: "caass-sgadvanced-incident",
	templateUrl: "./sgadvanced-incident.component.html",
	styleUrls: ["./sgadvanced-incident.component.css"],
})
export class SGAdvancedIncidentComponent implements OnInit {
	constructor(
		// private dataService: DataService_discipline,
		private dataService: GroupActionService,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		public dialogConfig: DynamicDialogConfig,
		private refreshService: StudentGroupsTableRefreshService
	) {}

	ngOnInit() {
		this.isBusy = true;

		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.GroupName = this.SelectedGroup.GroupName;

		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.user = this.dialogConfig.data.user;

		this.UserID = this.user.userID;
		this.UserLevelID = this.user.UserLevelID;
		// this.PersonID = this.dialogConfig.data.user.personID;

		this.IncidentID = this.dialogConfig.data.IncidentID;

		this.isAdd = true;

		let parm: wsGroupActionAdvancedIncidentDataParm = {
			UserID: this.UserID,
			GroupActionID: -1,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.GroupActionAdvancedIncidentGetData(parm).subscribe((data) => this.GroupActionAdvancedIncidentGetData_Complete(data));
	}

	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	//
	// Group
	//

	SelectedGroup: any;
	user: any;

	GroupName: any = "";

	SelectedPromptTypeID: any = 0;
	lstPromptType: any = [
		{
			ID: 0,
			Desc: "Automatically assigned to new group members",
		},
		{
			ID: 1,
			Desc: "Optional group action for new group members",
		},
	];

	//
	// From Discipline
	//

	@ViewChild("dtComments") dtComments: Table;
	@ViewChild("dtAssignedInfractions") dtAssignedInfractions: Table;
	@ViewChild("dtUnassignedInfractions") dtUnassignedInfractions: Table;
	@ViewChild("filterInfractionSchoolsDesc", { static: false })
	public filterInfractionSchoolsDesc: Dropdown;
	@ViewChild("filterInfractionDefinedByDesc", { static: false })
	public filterInfractionDefinedByDesc: Dropdown;

	@ViewChild("dtAssignedActions") dtAssignedActions: Table;
	@ViewChild("dtUnassignedActions") dtUnassignedActions: Table;
	@ViewChild("filterActionSchoolsDesc", { static: false })
	public filterActionSchoolsDesc: Dropdown;
	@ViewChild("filterActionDefinedByDesc", { static: false })
	public filterActionDefinedByDesc: Dropdown;

	public isBusy: boolean = false;
	public isShowInfractionAInfo: boolean = false;
	public isShowInfractionUInfo: boolean = false;
	public isShowActionAInfo: boolean = false;
	public isShowActionUInfo: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public PersonID: number = -1;
	public IncidentID: number = -1;
	public SchoolID: number = -1;
	public isAdd: boolean = false;

	public IncidentData: wsGroupActionAdvancedIncidentDataInfo;
	public RefreshPenaltyData: wsGroupActionAdvancedIncidentPenaltyRefreshInfo;

	public lstFacilityLocationItems: wsGroupActionAdvancedIncidentFacilityLocationDataInfo[] = [];
	public SelectedFacilityLocation: wsGroupActionAdvancedIncidentFacilityLocationDataInfo;
	public lstCommentItems: wsGroupActionAdvancedIncidentCommentInfo[] = [];
	public SelectedComment: wsGroupActionAdvancedIncidentCommentInfo;

	public lstAssignedInfractionItems: wsGroupActionAdvancedIncidentAssignedInfractionInfo[] = [];
	public SelectedAssignedInfraction: wsGroupActionAdvancedIncidentAssignedInfractionInfo;
	public lstInfractionItems: wsGroupActionAdvancedIncidentInfractionInfo[] = [];
	public SelectedInfraction: wsGroupActionAdvancedIncidentInfractionInfo;

	public lstAssignedPenaltyItems: wsGroupActionAdvancedIncidentAssignedPenaltyInfo[] = [];
	public SelectedAssignedPenalty: wsGroupActionAdvancedIncidentAssignedPenaltyInfo;
	public lstPenaltyItems: wsGroupActionAdvancedIncidentPenaltyInfo[] = [];
	public SelectedPenalty: wsGroupActionAdvancedIncidentPenaltyInfo;

	public rAdminName: string = "";
	public rStudentID: string = "";
	public rFirstName: string = "";
	public rLastName: string = "";
	public rIncidentDT: Date = null;
	public rContinueAlert: boolean = false;
	public rIsUseDayCount: boolean = false;
	public rMinDurationDayCount: number = 1;
	public rMaxDurationDayCount: number = 1;
	public rHasSusp: boolean = false;
	public selectedRadioValue: string = "1";

	//	RadioValue3
	public rSuspNbrDays1: number = 1;
	public rStartDate1: Date = null;
	public rEndDate1: Date = null;

	//	RadioValue4
	public rSuspNbrDays2: number = 1;
	public rStartDate2: Date = null;
	public rEndDate2: Date = null;

	//	Sound Player
	public mp3Player: any = new Audio();

	//	DataTable page counts
	public C_pagefirst: number = 0;
	public C_pagerows: number = 3;

	public AI_pagefirst: number = 0;
	public AI_pagerows: number = 3;
	public UI_pagefirst: number = 0;
	public UI_pagerows: number = 5;

	public AA_pagefirst: number = 0;
	public AA_pagerows: number = 3;
	public UA_pagefirst: number = 0;
	public UA_pagerows: number = 5;

	//	Filters
	public lstInfractionSchoolsDescs: any = [];
	public lstInfractionDefinedByDescs: any = [];
	public lstActionSchoolsDescs: any = [];
	public lstActionDefinedByDescs: any = [];

	//	Error Messaging
	public ErrorMessage: string = "";

	// Portal Apps
	public ParentPortalSendNotification: boolean = false;
	public StudentPortalSendNotification: boolean = false;
	public StaffPortalSendNotification: boolean = false;

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	GroupActionAdvancedIncidentGetData_Complete(data: any) {
		this.IncidentData = data;

		this.lstFacilityLocationItems = this.IncidentData.FacilityLocationItems;
		this.lstCommentItems = this.IncidentData.CommentItems;
		this.lstAssignedInfractionItems = this.IncidentData.AssignedInfractionItems;
		this.lstAssignedPenaltyItems = this.IncidentData.AssignedPenaltyItems;
		this.lstInfractionItems = this.IncidentData.InfractionItems;
		this.lstPenaltyItems = this.IncidentData.PenaltyItems;

		this.rAdminName = this.IncidentData.AdminName;
		this.rStudentID = this.IncidentData.StudentID;
		this.rFirstName = this.IncidentData.FirstName;
		this.rLastName = this.IncidentData.LastName;
		this.rContinueAlert = this.IncidentData.ContinueAlert;

		this.rIsUseDayCount = this.IncidentData.IsUseDayCount;
		this.rSuspNbrDays1 = this.IncidentData.DayCount;
		this.rSuspNbrDays2 = this.IncidentData.DayCount;

		this.rStartDate1 = null; // Set Later
		this.rEndDate1 = null; // Set Later
		this.rStartDate2 = null; // Set Later
		this.rEndDate2 = null; // Set Later

		this.rHasSusp = false;
		this.rMinDurationDayCount = 0;
		this.rMaxDurationDayCount = 0;

		//
		//	Select Default Facility Location
		//
		this.lstFacilityLocationItems.unshift({
			FacilityLocationID: -1,
			FacilityLocationCD: "",
			FacilityLocationName: "(None Selected)",
		});

		this.SelectedFacilityLocation = this.lstFacilityLocationItems[0];

		this.lstFacilityLocationItems.forEach((item) => {
			if (item.FacilityLocationID == this.IncidentData.FacilityLocationID) {
				this.SelectedFacilityLocation = item;
			}
		});

		//
		//	Set SUSP info if have SUSP
		//
		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
				this.rMinDurationDayCount = item.MinDurationDayCount; // Will only have 1 susp per Incident
				this.rMaxDurationDayCount = item.MaxDurationDayCount; // Will only have 1 susp per Incident
			}
		});

		if (this.rIsUseDayCount == false) {
			this.selectedRadioValue = "1"; // Date Range
		} else {
			this.selectedRadioValue = "2"; // Day Count
		}

		// Start / End Date
		if (this.IncidentData.StartDate != null) {
			this.rStartDate1 = new Date(this.IncidentData.StartDate); // Must do new for this to work
			this.rStartDate2 = new Date(this.IncidentData.StartDate); // Must do new for this to work
		}

		if (this.IncidentData.EndDate != null) {
			this.rEndDate1 = new Date(this.IncidentData.EndDate); // Must do new for this to work
			this.rEndDate2 = new Date(this.IncidentData.EndDate); // Must do new for this to work
		}

		// SET IncidentDT
		if (this.IncidentData.IncidentDT == null) {
			this.rIncidentDT = null;
		} else {
			this.rIncidentDT = new Date(this.IncidentData.IncidentDT); // Must do new for this to work
		}

		//
		//	Set Filter Lists
		//
		this.lstInfractionSchoolsDescs = Array.from(new Set(this.lstInfractionItems.map((item: any) => item.SchoolsDesc))).sort();
		this.lstInfractionDefinedByDescs = Array.from(new Set(this.lstInfractionItems.map((item: any) => item.DefinedByDesc))).sort();

		this.lstActionSchoolsDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.SchoolsDesc))).sort();
		this.lstActionDefinedByDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.DefinedByDesc))).sort();

		//
		//	Set Filter Defaults
		//
		this.onSetInfractionFilterDefaults();
		this.onSetActionFilterDefaults();

		//
		//	Reset Sort
		//
		this.dtComments.multiSortMeta = [];
		this.dtComments.multiSortMeta.push({ field: "c_date", order: -1 }); // DESC)
		this.dtComments.sortMultiple();

		this.dtAssignedInfractions.multiSortMeta = [];
		this.dtAssignedInfractions.multiSortMeta.push({
			field: "InfractionDesc",
			order: 1,
		});
		this.dtAssignedInfractions.sortMultiple();

		this.dtUnassignedInfractions.multiSortMeta = [];
		this.dtUnassignedInfractions.multiSortMeta.push({
			field: "InfractionDesc",
			order: 1,
		});
		this.dtUnassignedInfractions.sortMultiple();

		this.dtAssignedActions.multiSortMeta = [];
		this.dtAssignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtAssignedActions.sortMultiple();

		this.dtUnassignedActions.multiSortMeta = [];
		this.dtUnassignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtUnassignedActions.sortMultiple();

		this.ParentPortalSendNotification = this.IncidentData.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.IncidentData.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.IncidentData.StaffPortalSendNotification;

		this.isBusy = false;
	}

	GroupActionAdvancedIncidentGetCalendarData_Complete(data: any) {
		var CalendarData: wsGroupActionAdvancedIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.rSuspNbrDays1 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			}

			if (this.rSuspNbrDays1 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.isBusy = false;
	}

	GroupActionAdvancedIncidentRefreshPenalty_Complete(data: any) {
		this.RefreshPenaltyData = data;

		this.SelectedPenalty = null;
		this.lstPenaltyItems = this.RefreshPenaltyData.PenaltyItems;

		//
		//	Set Filter Lists
		//
		this.lstActionSchoolsDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.SchoolsDesc))).sort();
		this.lstActionDefinedByDescs = Array.from(new Set(this.lstPenaltyItems.map((item: any) => item.DefinedByDesc))).sort();

		//
		//	Set Filter Defaults
		//
		this.onSetActionFilterDefaults();

		//
		//	Reset Sort
		//
		this.dtAssignedActions.multiSortMeta = [];
		this.dtAssignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtAssignedActions.sortMultiple();

		this.dtUnassignedActions.multiSortMeta = [];
		this.dtUnassignedActions.multiSortMeta.push({
			field: "PenaltyDesc",
			order: 1,
		});
		this.dtUnassignedActions.sortMultiple();

		this.isBusy = false;
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////
	onAddComment() {
		this.ErrorMessage = "";

		//
		//	Display Edit Popup
		//
		let popup_header = "Add Comment";

		var ref = this.dialogService.open(GroupActionCommentComponent, {
			header: popup_header,
			width: "600px",
			data: {
				IncidentImageID: "",
				IncidentImageTitle: "",
				IncidentImageComment: "",
			},
		});

		ref.onClose.subscribe((response) => {
			if (response != null && response.isSave == true) {
				//
				//	Refresh Comment List
				//
				let rComment: wsGroupActionAdvancedIncidentCommentInfo = {
					IncidentImageID: response.IncidentImageID,
					c_date: new Date(),
					IncidentImageTitle: response.IncidentImageTitle,
					IncidentImageComment: response.IncidentImageComment,
					StaffName: this.rAdminName,
				};

				this.lstCommentItems = [...this.lstCommentItems, rComment];
			}
		});
	}

	onEditComment() {
		this.ErrorMessage = "";

		if (this.SelectedComment == null) {
			this.ErrorMessage = "Please select a comment to edit.";
			return;
		}

		//
		//	Display Edit Popup
		//
		let popup_header = "Edit Comment";

		var ref = this.dialogService.open(GroupActionCommentComponent, {
			header: popup_header,
			width: "600px",
			data: {
				IncidentImageID: this.SelectedComment.IncidentImageID,
				IncidentImageTitle: this.SelectedComment.IncidentImageTitle,
				IncidentImageComment: this.SelectedComment.IncidentImageComment,
			},
		});

		ref.onClose.subscribe((response) => {
			if (response != null && response.isSave == true) {
				//
				//	Refresh Comment List
				//
				if (this.SelectedComment.IncidentImageID == response.IncidentImageID) {
					this.SelectedComment.c_date = new Date();
					this.SelectedComment.IncidentImageTitle = response.IncidentImageTitle;
					this.SelectedComment.IncidentImageComment = response.IncidentImageComment;
				}
			}
		});
	}

	onRemoveComment() {
		this.ErrorMessage = "";

		if (this.SelectedComment == null) {
			this.ErrorMessage = "Please select a comment to remove.";
			return;
		}

		//
		// Confirm Remove
		//
		var message =
			"You are about to remove the comment '" +
			this.SelectedComment.IncidentImageComment +
			"' that was last changed on " +
			moment(this.SelectedComment.c_date).format("MMM d, YYYY, h:mm a") +
			". <br><br>" +
			"Do you wish to continue?";

		this.confirmationService.confirm({
			message: message,
			header: "Remove Comment",
			icon: "fa fa-info",
			accept: () => {
				//
				//	Remove The Selected Comment
				//
				this.lstCommentItems = this.lstCommentItems.filter((obj) => obj != this.SelectedComment);
				this.SelectedComment = null;
			},
			reject: () => {},
		});
	}

	onPlayAssigned() {
		if (this.SelectedAssignedPenalty != null && this.SelectedAssignedPenalty.SoundData.length > 10) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedAssignedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	onStopAssigned() {
		this.mp3Player.pause();
	}

	onPlayAssignable() {
		if (this.SelectedPenalty != null && this.SelectedPenalty.SoundData.length > 10) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	onStopAssignable() {
		this.mp3Player.pause();
	}

	onToggleInfractionAInfo() {
		this.isShowInfractionAInfo = !this.isShowInfractionAInfo;
	}

	onToggleInfractionUInfo() {
		this.isShowInfractionUInfo = !this.isShowInfractionUInfo;
	}

	onRemoveInfraction() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedInfraction == null) {
			this.ErrorMessage = "Please select an assigned infraction to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedInfractionItems = this.lstAssignedInfractionItems.filter((obj) => obj != this.SelectedAssignedInfraction);
		this.SelectedAssignedInfraction = null;

		//
		//	Refresh Assignable Action List
		//
		let AssignedInfractionItems: wsGroupActionAdvancedIncidentPenaltyRefreshInfractionsParm[] = [];

		this.lstAssignedInfractionItems.forEach((item) => {
			AssignedInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		let parm: wsGroupActionAdvancedIncidentPenaltyRefreshParm = {
			SchoolID: this.SchoolID,
			AssignedInfractionItems: AssignedInfractionItems,
		};

		this.isBusy = true;
		this.dataService.GroupActionAdvancedIncidentRefreshPenalty(parm).subscribe((data) => this.GroupActionAdvancedIncidentRefreshPenalty_Complete(data));
	}

	onAssignInfraction() {
		this.ErrorMessage = "";

		if (this.SelectedInfraction == null) {
			this.ErrorMessage = "Please select an infraction to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedInfractionItems.forEach((item) => {
			if (item.InfractionID == this.SelectedInfraction.InfractionID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This infraction has already been assigned.";
			return;
		}

		let rInf: wsGroupActionAdvancedIncidentAssignedInfractionInfo = {
			InfractionID: this.SelectedInfraction.InfractionID,
			isPrimary: false,
			InfractionCD: this.SelectedInfraction.InfractionCD,
			InfractionDesc: this.SelectedInfraction.InfractionDesc,
			InfractionLevelDesc: this.SelectedInfraction.InfractionLevelDesc,
			DefinedByID: this.SelectedInfraction.DefinedByID,
			DefinedByDesc: this.SelectedInfraction.DefinedByDesc,
			SchoolID: this.SelectedInfraction.SchoolID,
			SchoolsDesc: this.SelectedInfraction.SchoolsDesc,
		};

		this.lstAssignedInfractionItems = [...this.lstAssignedInfractionItems, rInf];
		this.SelectedInfraction = null;

		//
		//	Refresh Assignable Action List
		//
		let AssignedInfractionItems: wsGroupActionAdvancedIncidentPenaltyRefreshInfractionsParm[] = [];

		this.lstAssignedInfractionItems.forEach((item) => {
			AssignedInfractionItems.push({
				InfractionID: item.InfractionID,
				isPrimary: item.isPrimary,
			});
		});

		let parm: wsGroupActionAdvancedIncidentPenaltyRefreshParm = {
			SchoolID: this.SchoolID,
			AssignedInfractionItems: AssignedInfractionItems,
		};

		this.isBusy = true;
		this.dataService.GroupActionAdvancedIncidentRefreshPenalty(parm).subscribe((data) => this.GroupActionAdvancedIncidentRefreshPenalty_Complete(data));
	}

	onToggleActionAInfo() {
		this.isShowActionAInfo = !this.isShowActionAInfo;
	}

	onToggleActionUInfo() {
		this.isShowActionUInfo = !this.isShowActionUInfo;
	}

	onRemoveAction() {
		this.ErrorMessage = "";

		if (this.SelectedAssignedPenalty == null) {
			this.ErrorMessage = "Please select an assigned action to remove.";
			return;
		}

		//
		//	Remove The Selected Item
		//
		this.lstAssignedPenaltyItems = this.lstAssignedPenaltyItems.filter((obj) => obj != this.SelectedAssignedPenalty);
		this.SelectedAssignedPenalty = null;

		//
		//	SUSP Check
		//
		this.rHasSusp = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
			}
		});
	}

	onAssignAction() {
		this.ErrorMessage = "";

		if (this.SelectedPenalty == null) {
			this.ErrorMessage = "Please select an action to assign.";
			return;
		}

		let isItemExists: Boolean = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.SelectedPenalty.PenaltyID) {
				isItemExists = true;
			}
		});

		if (isItemExists == true) {
			this.ErrorMessage = "This action has already been assigned.";
			return;
		}

		if (this.rHasSusp == true) {
			if (this.SelectedPenalty.isSusp == true) {
				this.ErrorMessage =
					"A Suspension Action is already assigned to this incident. You can only have one suspension type assigned to an incident at a time.";
				return;
			}
		}

		let rPen: wsGroupActionAdvancedIncidentAssignedPenaltyInfo = {
			PenaltyID: this.SelectedPenalty.PenaltyID,
			isPrimary: false,
			PenaltyCD: this.SelectedPenalty.PenaltyCD,
			PenaltyDesc: this.SelectedPenalty.PenaltyDesc,
			AlertID: this.SelectedPenalty.AlertID,
			Message: this.SelectedPenalty.Message,
			FontColor: this.SelectedPenalty.FontColor,
			DefinedByID: this.SelectedPenalty.DefinedByID,
			DefinedByDesc: this.SelectedPenalty.DefinedByDesc,
			SchoolID: this.SelectedPenalty.SchoolID,
			SchoolsDesc: this.SelectedPenalty.SchoolsDesc,
			isSusp: this.SelectedPenalty.isSusp,
			MinDurationDayCount: this.SelectedPenalty.MinDurationDayCount,
			MaxDurationDayCount: this.SelectedPenalty.MaxDurationDayCount,
			SoundData: this.SelectedPenalty.SoundData,
		};

		this.lstAssignedPenaltyItems = [...this.lstAssignedPenaltyItems, rPen];
		this.SelectedPenalty = null;

		//
		//	SUSP Check
		//
		this.rHasSusp = false;

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (item.isSusp == true) {
				this.rHasSusp = true;
				this.rMinDurationDayCount = item.MinDurationDayCount; // Will only have 1 susp per Incident
				this.rMaxDurationDayCount = item.MaxDurationDayCount; // Will only have 1 susp per Incident
			}
		});

		if (this.rHasSusp != false) {
			// this.rHasSusp == true throws an error (Bug in VS Code)
			if (this.selectedRadioValue == "1") {
				//
				// Date Range
				//
				this.ValidateOption1Change();
			} else {
				//
				// Day Count
				//
				this.ValidateOption2Change();
			}
		}
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////

	onSetInfractionFilterDefaults() {
		this.dtUnassignedInfractions.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.dtUnassignedInfractions.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	onSetActionFilterDefaults() {
		this.dtUnassignedActions.filters.SchoolsDesc["value"] = null; // Default To 'Any'
		this.dtUnassignedActions.filters.DefinedByDesc["value"] = null; // Default To 'Any'
	}

	onRowDblClick(item: any) {
		this.onEditComment();
	}

	onFacilityLocationChange(e: any) {}

	onRadioChange() {
		if (this.selectedRadioValue == "1") {
			this.ValidateOption1Change();
		} else {
			this.ValidateOption2Change();
		}
	}

	onStartDate1Change(val) {
		this.rStartDate1 = val;
		this.ValidateOption1Change();
	}

	onEndDate1Change(val) {
		this.rEndDate1 = val;
		this.ValidateOption1Change();
	}

	ValidateOption1Change() {
		this.ErrorMessage = "";

		if (this.rStartDate1 != null) {
			if (this.rStartDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rEndDate1 != null) {
			if (this.rEndDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rStartDate1 > this.rEndDate1) {
			this.ErrorMessage = "Start Date cannot be greater than End Date";
			return;
		}

		let parm: wsGroupActionAdvancedIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate1,
			EndDate: this.rEndDate1,
			IsUseDayCount: false,
			DayCount: -1,
		};

		this.isBusy = true;
		this.dataService.GroupActionAdvancedIncidentGetCalendarData(parm).subscribe((data) => this.GroupActionAdvancedIncidentGetCalendarData_Complete(data));
	}

	onSuspNbrDays2(val) {
		this.rSuspNbrDays2 = val;
		this.ValidateOption2Change();
	}

	onStartDate2Change(val) {
		this.rStartDate2 = val;
		this.ValidateOption2Change();
	}

	onEndDate2Change(val) {
		this.rEndDate2 = val;
		this.ValidateOption2Change();
	}

	ValidateOption2Change() {
		this.ErrorMessage = "";

		if (isNaN(Number(this.rSuspNbrDays2))) {
			this.ErrorMessage = "Number of days is not a number.";
			return;
		}

		if (Number(this.rSuspNbrDays2 < 1)) {
			this.ErrorMessage = "Number of days must be greater than 0.";
			return;
		}

		if (this.rSuspNbrDays2 < this.rMinDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			return;
		}

		if (this.rSuspNbrDays2 > this.rMaxDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			return;
		}

		if (this.rStartDate2 != null) {
			if (this.rStartDate2.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		let parm: wsGroupActionAdvancedIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate2,
			EndDate: null,
			IsUseDayCount: true,
			DayCount: this.rSuspNbrDays2,
		};

		this.isBusy = true;
		this.dataService.GroupActionAdvancedIncidentGetCalendarData(parm).subscribe((data) => this.GroupActionAdvancedIncidentGetCalendarData_Complete(data));
	}

	onChangePrimaryInfraction(e: any) {
		this.ErrorMessage = "";

		this.lstAssignedInfractionItems.forEach((item) => {
			if (e.InfractionID != item.InfractionID) {
				item.isPrimary = false;
			}
		});
	}

	onHandleSort_C(e: any) {}

	onHandleSort_AI(e: any) {}

	onHandleSort_UI(e: any) {}

	onRowSelect_C(event) {}

	onRowUnselect_C(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedComment = event.data;
	}

	onRowSelect_AI(event) {}

	onRowUnselect_AI(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedAssignedInfraction = event.data;
	}

	onRowSelectUI(event) {}

	onRowUnselectUI(event) {
		//
		//	Need to set SelectedInfraction here. We don't unselect when selected.
		//
		this.SelectedInfraction = event.data;
	}

	onChangePrimaryAction(e: any) {
		this.ErrorMessage = "";

		this.lstAssignedPenaltyItems.forEach((item) => {
			if (e.PenaltyID != item.PenaltyID) {
				item.isPrimary = false;
			}
		});
	}

	onHandleSort_AA(e: any) {}

	onHandleSort_UA(e: any) {}

	onRowSelect_AA(event) {}

	onRowUnselect_AA(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedAssignedPenalty = event.data;
	}

	onRowSelectUA(event) {}

	onRowUnselectUA(event) {
		//
		//	Need to set SelectedPenalty here. We don't unselect when selected.
		//
		this.SelectedPenalty = event.data;
	}

	GroupActionAdvancedIncidentAdd_Complete(data: any) {
		this.isBusy = false;
		// this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.AllClear(data) == true) {
			//Success Dialog
			this.confirmationService.confirm({
				key: "advanced",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Advanced Group Action Incident was added successfully",
				header: "Success",
				icon: "fa",
				accept: () => {
					this.refreshService.GroupActionRefreshChanged(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"));
					this.ref.close(1);
				},
			});
		} else {
			//Fail Dialog
			this.confirmationService.confirm({
				key: "advanced",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Could Not add the Group Action Incident",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		}
	}

	//////////////////////////////////////////////////////////

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}
}
